import { controls,grouped } from "../controls";
const form_groups = {
label: "Form Groups",
pageLabel: "Form Groups",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Form Group Items",uid: "form_group_items",fastpath:"form_group_items"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "form_group_code",maxlength:30}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "form_group_display",width:"col-sm-4",maxlength:100}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "form_group_code",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "form_group_display",width:"col-sm-4",maxlength:100}),
...controls.checkBox({ tab: "general", label: "Active",default:true, name: "form_group_active" }),
...controls.displayText({ tab: "form_group_items", label: "Form",star:false}),
...controls.oc({ tab: "form_group_items", c: "Form", placeHolder: "Form Code", name: "form_code",fastpath: "forms",hidden:false}),
...controls.showData({ tab: "form_group_items", displaytype: "capital", data: "form_display"}),
...controls.displayText({ tab: "form_group_items", label: "Sequence",star:false}),
...controls.numberOnly({ tab: "form_group_items",  placeHolder: "", name: "sequence",maxlength:200}),
...controls.displayText({ tab: "form_group_items", label: ""}),

...controls.displayText({ tab:"form_group_items" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"form_group_items" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"form_group_items",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "form_group_items",
  requiredField: ["form_code","form_display","form_uid","sequence",],
required:[],
}, width: "col-sm-2"
}),
...controls.button({
tab:"form_group_items",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "form_group_items",
  requiredField: ["form_code","form_display","form_uid","sequence",]
}, width: "col-sm-2"
}),
{
  tab:"form_group_items",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Form Code", field: "form_code"},
    { label: "Form ", field: "form_display"},
    { label: "Sequence", field: "sequence"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "form_group_items"
},
]
,history:{
perPage: 10,
reportHeader: "Form Groups",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Form Group Code",accessor: "form_group_code",},
{Header: "Form Group",accessor: "form_group_display",},
]}};
export default form_groups;